import { FDInvestmentJourneyResponseType } from '../../../types/fd-type'
import RenderHTML from '../../ui-components/RenderHTML'
import { Progress } from './Progress'

export const ProgressStep = ({
  data,
  currentInvestment
}: {
  data: FDInvestmentJourneyResponseType | undefined
  currentInvestment: number
}) => {
  return (
    <div className='flex flex-col justify-center px-5 w-full h-full'>
      <div className='text-white opacity-70 pb-3 text-[22px] text-center'>You’re almost done</div>
      <div className='text-white text-[32px] font-[500] leading-[120%] text-center w-full pb-8'>
        Let’s complete your FD booking
      </div>
      <Progress data={data} currentInvestment={currentInvestment} />
      <div className='flex gap-3 pt-7 pb-3'>
        <div className='text-sm'>
          <div className='relative flex flex-col justify-center items-center rounded-full h-11 w-11 border bg-[#1691DC] border-[#33A7E4]'>
            <RenderHTML innerHTMLText={CustomerSupport24x7Icon} />
            <div
              className='text-[10px] font-[500] bg-white w-[33px] h-4 rounded-[5px] 
            flex justify-center items-center text-[#1095DF] absolute -bottom-2'
            >
              24x7
            </div>
          </div>
        </div>
        <div className='text-[#BEE3FB] text-[13px] pt-2'>
          <span className='text-white'> We’re here for you, always. </span> A PowerUp RM is now assigned to assist you
          throughout.
        </div>
      </div>
    </div>
  )
}

const CustomerSupport24x7Icon = `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
  <path d="M6.01562 8.86161V7.4375C6.01562 4.6847 8.2472 2.45312 11 2.45312C13.7528 2.45312 15.9844 4.6847 15.9844 7.4375V16.6942C15.9844 18.2673 14.7092 19.5424 13.1362 19.5424H11" stroke="#D1ECFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M15.9844 14.5558V8.85938H18.1205C18.9071 8.85938 19.5446 9.49698 19.5446 10.2835V13.1317C19.5446 13.9182 18.9071 14.5558 18.1205 14.5558H15.9844Z" stroke="#D1ECFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M2.45508 13.1317V10.2835C2.45508 9.49698 3.09268 8.85938 3.87919 8.85938H6.01535V14.5558H3.87919C3.09268 14.5558 2.45508 13.9182 2.45508 13.1317Z" stroke="#D1ECFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`
